import React, { useState } from 'react'
import { ENTITYNAME } from '../../framework/constant/constant';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { useTranslation } from '../../locale/useTranslation';
import AddRoundButton from '../../framework/forms/helpercomponents/buttons/AddRoundButton';
import DeleteRoundButton from '../../framework/forms/helpercomponents/buttons/DeleteRoundButton';
import { ConfirmAlert, ConfirmDeleteAlert } from '../../ConfirmAlert';
import CollectionSelection from '../../framework/forms/CollectionSelection';
import { DateOnlyCell } from '../../framework/forms/helpercomponents/CustomGridCells/DateCell';
import { ImageCell } from '../../framework/forms/helpercomponents/CustomGridCells/ImageCell';
import MyStatusCell from '../../components/MyStatusCell';
import { utility } from '../../framework/utility/utilityProvider';

export const ProviderTabForm = (props) => {
  
    const { data = [], setProviderData } = props;
    const lang = useTranslation();
    const [showProvider, setShowProvider] = useState(false);

    const handleProviderData = (dataList) => {
      let finalData = utility.checkDuplicateInData(dataList, data, "Description");
      setProviderData([...data, ...finalData]);
    }

    const Mystatuscell = (props) => {
        let tileBackColor = props.dataItem.IsActive ? "#63aa43" : "#E72929";
        return <MyStatusCell title={props.dataItem.IsActive ? "Active" : "Deactive"} tileBackColor={tileBackColor} />
    }

    const deleteData = (dataItem) => {
      let newData = data.filter(item => item._id !== dataItem._id);
      setProviderData(newData);
    }

    const MyCommandCell = (props) => (
        <div className="mt-3 ml-4" style={{ display: "flex" }}>
            <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => deleteData(props.dataItem), () => { })} />
        </div>
    )

    const deleteAllData = () => {
        setProviderData([]);
    }

    return (
        <>
            <AddRoundButton onClick={() => setShowProvider(true)} style={{ marginLeft: "-15px" }} title={lang.add_provider_button_tooltip} />
            {data.length > 0 && <DeleteRoundButton style={{ marginLeft: "10px" }} title={lang.delete_all_button_tooltip} onClick={() => ConfirmAlert(() => deleteAllData(), () => { }, lang.confirm_delete_all_label, lang.are_you_sure_do_you_want_to_delete_all_label)} />}

            <Grid data={data} style={{ height: "35vh", margin: "5px -15px 0px -15px" }} resizable>
                <GridColumn cell={MyCommandCell} width={"80px"} locked={true} />
                <GridColumn field="LogoUrl" title={lang.provider_label} editable={false} cell={ImageCell} width={"100px"} />
                <GridColumn field="Description" title={lang.name_column} editable={false} width={250}/>
                <GridColumn field="IsActive" title={lang.status_label} editable={false} cell={Mystatuscell} width={"150px"} />
                <GridColumn field="StartDate" title={lang.start_date_label} editable={false} cell={DateOnlyCell} />
            </Grid>

            {showProvider && <CollectionSelection title={lang.select_provider_label} setDataList={handleProviderData} entityname={ENTITYNAME.OttProvider} closeForm={() => setShowProvider(false)} mode={'multiple'} width={"50vw"} />}
        </>
    )
}
